<template>
  <app-view>
    <div class="blank"></div>
    <div class="user">
      <img :src="user.headimgurl">
      <div>{{ user.nickname }}</div>
    </div>
    <div class="blank"></div>
    <router-link :to="{ name: 'news' }">
      <i class="icon icon-oNews"></i>
      <span>站内公告</span>
      <i class="icon icon-right"></i>
    </router-link>
    <router-link :to="{ name: 'suggest' }">
      <i class="icon icon-oMail"></i>
      <span>留言反馈</span>
      <i class="icon icon-right"></i>
    </router-link>
    <div class="blank"></div>
    <a href="javascript:;" @click="onRoute('playback')">
      <i class="icon icon-oPlay"></i>
      <span>播放记录</span>
      <i class="icon icon-right"></i>
    </a>
    <a href="javascript:;" @click="onRoute('favourite')">
      <i class="icon icon-oStar"></i>
      <span>我的收藏</span>
      <i class="icon icon-right"></i>
    </a>
    <a href="javascript:;" @click="onRoute('note')">
      <i class="icon icon-oNote"></i>
      <span>我的笔记</span>
      <i class="icon icon-right"></i>
    </a>
    <div class="blank"></div>
    <a href="javascript:;" @click="onShare">
      <i class="icon icon-oShare"></i>
      <span>邀请好友</span>
      <i class="icon icon-right"></i>
    </a>
    <div class="blank"></div>
    <router-link :to="{ name: 'about' }">
      <i class="icon icon-oAbout"></i>
      <span>关于我们</span>
      <i class="icon icon-right"></i>
    </router-link>
    <!-- <router-link :to="{name:'prayer'}">
      <i class="icon icon-oHeart"></i>
      <span>
        代祷支持
        <i class="unread" v-if="prayer"></i>
      </span>
      <i class="icon icon-right"></i> -->
    </router-link>
  </app-view>
</template>
<script>
export default {
  data() {
    return {
      user: {}
    }
  },
  computed: {
    prayer() {
      return this.$service.other.prayer
    }
  },
  async mounted() {
    window.location.href = 'http://www.fytvapp.com/'
    this.user = await this.$service.user.loadCurrent()
    console.info(this.user)
  },
  methods: {
    onShare() {
      this.$service.common.share = true
    },
    async onRoute(name) {
      if (await this.$service.user.checkUserState(this, true)) {
        this.$router.push({ name })
      }
    }
  }
}
</script>
<style scoped lang='scss'>
.view {
  .user {
    display: flex;
    align-items: center;
    padding: $app-padding;
    background-color: $color-white;

    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      margin-right: 20px;
    }
  }

  >a {
    display: flex;
    background-color: $color-white;
    line-height: 44px;
    border-bottom: $style-border;
    padding: 0 $app-padding;

    &:active {
      background-color: rgba(0, 0, 0, 0.1);
    }

    >span {
      flex: 1;
      margin-left: $app-padding;

      .unread {
        position: relative;
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: $color-red;
        top: -10px;
      }
    }

    >i {
      font-size: 20px;
    }

    .icon-right {
      color: $thirdly-text-color;
    }

    .icon-oNews {
      color: #48caef;
    }

    .icon-oMail {
      color: #49a3f8;
    }

    .icon-oPlay {
      color: #13227a;
    }

    .icon-oStar {
      color: #d81e06;
    }

    .icon-oNote {
      color: #36ab60;
    }

    .icon-oShare {
      color: #e89abe;
    }

    .icon-oAbout {
      color: #ffd38d;
    }

    .icon-oHeart {
      color: #fc850f;
    }
  }

  .blank {
    height: $app-padding;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?df748c9c